/** @jsx jsx */
import { jsx } from '@emotion/react';

import Imgix from 'js/components/Imgix';

import { LogoWrapper } from '@coursera/cds-core';

import { NAV_SQUARE_LOGO_SIZE } from 'bundles/unified-description-page-common/constants';

import _t from 'i18n!nls/xdp';

type Props = {
  imageSrc?: string | null;
  partnerName?: string;
};

const NavPartnerLogo = ({ imageSrc, partnerName }: Props) => {
  if (!imageSrc) {
    return null;
  }

  return (
    <LogoWrapper paddingVariant="smallOutside">
      <Imgix
        src={imageSrc}
        alt={partnerName || _t('Partner')}
        maxWidth={NAV_SQUARE_LOGO_SIZE}
        maxHeight={NAV_SQUARE_LOGO_SIZE}
      />
    </LogoWrapper>
  );
};

export default NavPartnerLogo;
